<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!---->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fas fa-map-marked-alt" id="ico"></i>
		<h1 style="display:inline-block;">Mapa</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<mat-card>
		<div id="map-marker" class="map "></div>
</mat-card>
